import {useState} from 'react';
import {Skeleton, view, type CssProperties} from '@sail/ui';

interface Props {
  iconUrl: string;
  name: string;
  width?: CssProperties['width'];
  height?: CssProperties['height'];
  borderRadius?: CssProperties['borderRadius'];
}

export const WalletConnectIcon = ({
  iconUrl,
  name,
  width = '44px',
  height = '44px',
  borderRadius = 'large',
}: Props) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <view.div
      css={{
        stack: 'z',
        width: 'fit',
        height: 'fit',
      }}
    >
      {isLoading ? <Skeleton css={{width, height}} /> : null}
      <view.img
        src={iconUrl}
        alt={name}
        css={{
          // Keep the image hidden until it's loaded.
          // It has to be in the DOM to start loading the image.
          opacity: isLoading ? 0 : 1,
          transition: 'opacity 150ms ease-in-out',
          height,
          width,
          borderRadius,
          alignSelf: 'center',
          objectFit: 'contain',
        }}
        onLoad={() => setIsLoading(false)}
      />
    </view.div>
  );
};
